/**
 * Start the registration ceromony.
 *
 * @param {Number} personId - The persoName.
 * @param {String} userName - The userName.
 * @param {String} displayName - The screenName.
 */
export async function startRegistration(
  personId: Number,
  userName: String,
  displayName: String
) {
  const data = {
    personId: personId,
    userName: userName,
    displayName: displayName
  };
  return fetch('/webauthn/start-registration', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }).then((response) => {
    return response.json();
  });
}

/**
 * Finish the registration ceromony.
 *
 * @param {Number} personId - The personId.
 * @param {credential} credential - The pk credential from
 * navigator credential create.
 */
export async function finishRegistration(personId: Number, credential: Object) {
  const data = {
    personId: personId,
    credential: credential,
    response: credential.response
  };
  return fetch('/webauthn/finish-registration', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }).then((response) => {
    return response.json();
  });
}

/**
 * Start the authentication ceromony.
 *
 * @param {String} userName - The userName.
 */
export async function startAuthentication(userName: String) {
  const data = {
    userName: userName
  };
  return fetch('/webauthn/start-authentication', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'same-origin',
    body: JSON.stringify(data)
  }).then((response) => {
    return response.json();
  });
}

/**
 * Finish the authentication ceromony.
 *
 * @param {String} name - The userName.
 * @param {credential} credential - The pk credential from
 * navigator credential create.
 */
export async function finishAuthentication(name: String, credential: Object) {
  const data = {
    userName: name,
    credential: credential
  };
  return fetch('/webauthn/finish-authentication', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'same-origin',
    body: JSON.stringify(data)
  }).then((response) => {
    return response.json();
  });
}

/**
 * Polling action for session validation.
 * @param {boolean} active - indicates if the user interacting with the page.
 * navigator credential create.
 */
export async function validateSession() {
  return fetch('/session', {
    method: 'GET'
  }).then((response) => {
    return response.json();
  });
}
